/* istanbul ignore file */
import { DeleteButton } from 'framework/ui/ui-builder';
import useFinanceService from 'domain/people/employee/finance/shared/financeService';
import { useFinanceUrl, useFinanceId } from 'domain/people/employee/finance/financeRouting';
import { ButtonProps } from 'framework/ui/mui-builder';
import { useAuthorization } from 'framework/authorization';

const deleteMessage = 'Do you really want to delete this compensation package?';

const DeleteFinanceButton = ({
  permissionToCheck,
  ...props
}: ButtonProps & { permissionToCheck?: Nullable<string | string[]> }) => {
  const financeId = useFinanceId();
  const { deleteById } = useFinanceService();
  const { isGranted } = useAuthorization();

  const { getListUrl } = useFinanceUrl();

  if (permissionToCheck && !isGranted(permissionToCheck)) {
    return null;
  }

  return (
    <DeleteButton
      {...props}
      deleteMethod={() => deleteById(financeId)}
      displayMessage={deleteMessage}
      afterDelete={{
        redirectUrl: getListUrl(),
        successMessage: 'The Compensation package has been successfully deleted.',
        errorMessage: `Can't delete compensation package`,
      }}
    />
  );
};

export default DeleteFinanceButton;
